import React, { FC } from 'react';
import { View } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import Skeleton from '@v2/elements/Skeleton';
import { DashboardScope } from '@api/domain/types';

import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';
import { getRowContainerStyle, rowHasImage } from '@v2/pages/dashboard/common/helpers';
import type { WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';

interface DashboardListSkeletonRowProps extends WithColor, WithBorderRadiusConfig {
  scope: DashboardScope;
  testID?: string;
}

const DashboardListSkeletonRow: FC<DashboardListSkeletonRowProps> = ({ C, scope, borderRadiusConfig, testID }) => (
  <View testID={testID} style={getRowContainerStyle(scope, borderRadiusConfig)}>
    {rowHasImage(scope) && (
      <Skeleton
        C={C}
        width={scale(ROW_LAYOUT.image.width)}
        height={scale(ROW_LAYOUT.image.height)}
        borderRadius={scale(ROW_LAYOUT.image.borderRadius)}
        style={{ marginRight: scale(8) }}
      />
    )}
    <Skeleton
      C={C}
      width={scale(120)}
      height={scale(ROW_LAYOUT.skeleton.textHeight)}
      borderRadius={scale(ROW_LAYOUT.skeleton.textRadius)}
      style={{ marginRight: scale(12) }}
    />
    <Skeleton
      C={C}
      width="40%"
      height={scale(ROW_LAYOUT.bar.height)}
      borderRadius={scale(ROW_LAYOUT.bar.height / 2)}
      style={{ flex: 1 }}
    />
    <Skeleton
      C={C}
      width={scale(ROW_LAYOUT.skeleton.valueWidth)}
      height={scale(ROW_LAYOUT.skeleton.textHeight)}
      borderRadius={scale(ROW_LAYOUT.skeleton.textRadius)}
      style={{ marginLeft: scale(12) }}
    />
  </View>
);

export default ColorWrapper(DashboardListSkeletonRow);
